/**
 * @ Author: DY
 * @ Date: 2022-11-03 15:46:37
 * @ LastEditTime: 2023-01-18 17:22:06
 * @ Description:
 * @ FilePath: \ConcreteCloud.Mobile\src\promission.js
 */
/* eslint-disable */
import store from './store';
import router from './router';
// 是否有菜单数据
router.beforeEach(async (to, from, next) => {
    // 动态缓存组件
    if (to.meta.keepAlive == true) {
        store.commit('setKeepAlive', to.meta.componentName);
    }
    // 缓存滚动条高度
    if (from.meta.keepAlive == true) {
        let scrollTop;
        if (document.querySelector('.van-pull-refresh')) {
            scrollTop = document.querySelector('.van-pull-refresh').scrollTop;
            store.commit('recordScroll', { top: scrollTop, index: from.meta.hierarchy });
            var newClassName = 'van-pull-refresh' + from.meta.hierarchy;
            document.querySelector('.van-pull-refresh').classList.add(newClassName);
        }
    }
    // 返回清零滚动条高度
    if (from.meta.hierarchy > to.meta.hierarchy) {
        store.commit('recordScroll', { top: 0, index: from.meta.hierarchy });
    }
    if (to.name !== 'home' && to.name !== 'index') {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            if (to.name !== 'inHome') {
                window.$globalHub.$callMobile('JYTeamsNative', 'JYPushView', '');
            } else {
                window.$globalHub.$callMobile('JYTeamsNative', 'JYToHome', '');
            }
        } else {
            window.$globalHub.$callMobile('JYTeamsNative', 'JYPushView', '');
        }
    } else if (to.name === 'home' && from.name && from.name !== 'index' && !to.meta.hideBottomTabBar) {
        const user_type = window.$globalHub.$takeTokenParameters('User_Type');
        if (Number(user_type) === 1) {
            window.$globalHub.$callMobile('JYTeamsNative', 'JYToHome', '');
        } else {
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                window.$globalHub.$callMobile('JYTeamsNative', 'JYToHome', '');
            }
        }
    }
    next();
});
router.afterEach((to, from) => {
    if (to.name === 'home') {
        store.commit('deleteScroll');
    }
    if (to.meta.keepAlive == true) {
        setTimeout(() => {
            if (document.querySelector('.van-pull-refresh' + to.meta.hierarchy) === null) return;
            document.querySelector('.van-pull-refresh' + to.meta.hierarchy).scrollTop = store.state.scrollTop[to.meta.hierarchy];
        }, 10)
    }
})
